module.exports = __webpack_public_path__ + "img/andy.b6cc8edc.jpg";